// HRMS permission sets and add-on features. Mirrors the API's
// src/routes/hrms/common/config.js - keep the two in step.
//
// Menu visibility is driven by GET hrms/access (module enablement + the
// caller's permission sets), not only by ROLE_IDS / allowedRoles.
export const HR_PERMISSIONS = {
  HR_ADMIN: "HR_ADMIN",
  PAYROLL_ADMIN: "PAYROLL_ADMIN",
  HR_VIEWER: "HR_VIEWER",
  ATTENDANCE_ADMIN: "ATTENDANCE_ADMIN",
  FINANCE_APPROVER: "FINANCE_APPROVER",
};

// Core HR is unlocked by the vendor's plan (plan_type 3); these are the
// Super Admin add-on switches.
export const HR_FEATURES = {
  PAYROLL: "PAYROLL",
  EXPENSES: "EXPENSES",
  SCHEDULE_BRIDGE: "SCHEDULE_BRIDGE",
};

// HR is on for every plan. `enabled` / `full` = the full module (plan_type 3); `employees_enabled`
// = the Employees capability every plan has (the list, add / edit, ending employment), shown to
// the people who run the business. `enabled` keeps its old meaning, so every screen that reads
// it is unchanged.
export const EMPTY_HR_ACCESS = {
  enabled: false,
  full: false,
  tier: null,
  employees_enabled: false,
  features: {},
  permissions: [],
  is_tenant_admin: false,
};

// `access` is the `data` of GET hrms/access. Tenant owners / admins hold every
// permission; the API already expands that into `permissions`.
export function hasHrPermission(access, ...permissions) {
  if (!access || !access.enabled) return false;
  if (access.is_tenant_admin) return true;
  return permissions.some((p) => (access.permissions || []).includes(p));
}

// Can this person reach the Employees screens (either tier)?
export function hasEmployeesAccess(access) {
  return !!(access && (access.enabled || access.employees_enabled));
}

export function hasHrFeature(access, feature) {
  return !!(access && access.enabled && access.features && access.features[feature]);
}
